<template>

    <div v-if="loading">Loading...</div>

    <div v-else>
        <!-- Media advisories -->
        <div v-for="advisory in results" v-bind:key="advisory.id">
            <p class="ut-ct mt-3 mb-1"><router-link class="a_no_line font-weight-bold" :to="{ name: 'release', params: { lang: advisory.language, type: advisory.release_type_label, release_id: advisory.id, slug: advisory.unformatted_slug } }">{{ advisory.content_title }}</router-link></p>
            <p class="ut-fd feature_date font-weight-bold">{{ advisory.release_date_time_formatted }}</p>
            <hr />
        </div>
    </div>

</template>

<script>
export default {
  props: ['pagination', 'limit', 'type'],

  data () {
    return {
      results: [],
      loading: null
    }
  },
  methods: {
    //Get media advisories
    fetchData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'releases', {
          params: {
            language: this.$root.$i18n.locale, //get value from router information
            types: [this.type], //use media advisories - needs to be in array
            limit: this.limit, //only show the last three
            page: this.page //only show 1 page
          }
        })
        .then(response => {
          //Get advisories
          this.results = response.data.data
          //Flatten results array
          this.results = this.results.flat()
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (
          this.loading = false
        ))
    },
  },
  mounted () {
    this.fetchData()
  }
}
</script>
